import React, { useRef, useLayoutEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './Modal.scss';

const appRoot = document.getElementById('root');

Modal.propTypes = {
    className: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.any,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
};

Modal.defaultProps = {
    size: 'medium',
};

export default function Modal({ className, children, size, onClose }) {
    const portalRef = useRef(createPortalElement());

    useLayoutEffect(() => {
        function handlePortalClick(e) {
            if (e.target === portalRef.current) {
                onClose && onClose();
            }
        }

        appRoot.appendChild(portalRef.current);
        portalRef.current.addEventListener('click', handlePortalClick);

        return () => {
            portalRef.current.removeEventListener('click', handlePortalClick);
            appRoot.removeChild(portalRef.current);
        };
    }, []);

    const content = (
        <div className={classNames(styles.root, className, styles[size])}>
            <div className={styles.content}>{children}</div>
        </div>
    );

    return ReactDOM.createPortal(content, portalRef.current);
}

function createPortalElement() {
    const el = document.createElement('div');
    el.className = styles.portal;
    return el;
}
